<template>
  <main>
    <div class="container">
      <div class="page-content">
        <div class="row-group">


          <ul class="row-content tags-list">
            <li class="tag-square-base" v-for="(item,index) in pageImages" :key="item"  >
              <a :href="item" target="_blank">
                <!-- <img class="" :alt="item2.name"  :src="item2.img"> -->
                <video style="background-color: #bfb081;"  width="100%" height="200px" v-if="getMediaType(item) == 2" :src="item"
                     controls="controls"></video>

                <img  width="100%" height="200px" v-else :src="item"/>

                <!-- <span class="tag-title J_tag-title">{{item}}</span> -->
              </a>
            </li>
          </ul>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          >

          </el-pagination>
        </div>
      </div>

    </div>
  </main>
</template>

<script>
  export default {
    props: {
    images: {
      type: Array,
      required: false
    }
  },
    data() {
      return {
        dataImages:[],
        pageImages:[],
        currentPage: 1,
        pageSize: 20,
        total:100

      };
    },
    mounted() {
      this.dataImages = this.images;
      this.pageImages = this.dataImages.slice(0,this.pageSize)
      this.total = this.images.length

      console.log(this.images)
    },
    methods: {
      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.fetchData();
      },
      handleCurrentChange(newPage) {
        this.currentPage = newPage;
        this.fetchData();
      },
      fetchData() {
        let endIndex = this.currentPage * this.pageSize > this.dataImages.length? this.dataImages.length :  this.currentPage * this.pageSize;

        this.pageImages =  this.images.slice((this.currentPage-1) * this.pageSize,endIndex)

      },
      getMediaType(name) {

        let type = name.substring(name.lastIndexOf(".") + 1);

        let imgType = ['bmp', 'jpg', 'png', 'tif', 'gif', 'pcx', 'tga', 'exif', 'fpx', 'svg', 'psd', 'cdr', 'pcd', 'dxf', 'ufo', 'eps', 'ai', 'raw', 'WMF', 'webp', 'avif', 'apng'];

        if (imgType.some(e => e == type)) {
          return 1;
        }

        let videoType = ['mp4', 'mkv', 'avi', 'mov', 'wmv', '3gp', 'rm', 'rmvb']

        if (videoType.some(e => e == type)) {
          return 2
        }

        return 1;

      }
    }
  };
</script>

<style scoped>
  main {
    display: block;
    min-height: 300px;
  }
  ul, li, p {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .secondary-nav .nav-list li {
    display: inline-block;
    height: 28px;
    font-size: 14px;
    line-height: 28px;
  }
  .secondary-nav .nav-list li.active a {
    border-bottom: 2px solid #c99a05;
  }
  .secondary-nav .nav-list li a {
    position: relative;
    display: block;
    height: 100%;
    margin: 0 20px;
    color: #222;
    text-decoration: none;
  }
  .secondary-nav .nav-list li a:hover {
    border-bottom: 2px solid #c99a05;
    color: #c99a05;
  }

  .page-content {
    max-width: 1163px;
    min-width: 767px;
    margin: 0 auto;
  }
  .page-content .row-title {
    padding: 40px 0;
  }
  .page-content .row-title h2 {
    display: inline-block;
    overflow: hidden;
    letter-spacing: 10px;
    line-height: 1.19;
    font-size: 32px;
    margin: 0;
    vertical-align: bottom;
    font-weight: 500;
  }
  .page-content .text-linear {
    z-index: 0;
  }
  .text-linear {
    position: relative;
    z-index: 1;
  }
  .page-content .text-linear:after {
    top: 23px;
  }
  .text-linear:after {
    content: '';
    position: absolute;
    top: 10px;
    left: 12px;
    z-index: -1;
    width: 100%;
    height: 14px;
    background: -webkit-linear-gradient(
      0deg
      ,#c99a05 30%,rgba(255,255,255,0) 30%);
    background: -moz-linear-gradient(0deg,#c99a05 30%,rgba(255,255,255,0) 30%);
    background: linear-gradient(
      90deg
      ,#c99a05 30%,rgba(255,255,255,0) 30%);
    -moz-background-size: 3px 100%;
    background-size: 3px 100%;
  }
  .page-content .row-title .tags-all-link {
    color: #85888a;
    font-size: 16px;
    line-height: 22px;
    margin-left: 20px;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    color: inherit;
  }
  .page-content .tags-list {
    margin-right: -25px;
    margin-bottom: -25px;
    font-size: 0;
    max-width: 1188px;
    min-width: 792px;
  }
  ul, li, p {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .page-content .tags-list .tag-square-base {
    width: 173px;
    height: 100%;
    margin-right: 25px;
    margin-bottom: 25px;
    display: inline-block;
  }
  /* .page-content .tags-list .tag-square-base a {
    display: block;
    position: relative;
  } */
  /* .page-content .tags-list .tag-square-base a:before {
    content: '';
    background: rgba(0,0,0,.3);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  } */
  /* .page-content .tags-list .tag-square-base img {
    width: 100%;
    height: 100%;
  }

  .page-content .tags-list .tag-square-base video {
    width: 100%;
    height: 100%;
  } */


  .page-content .tags-list .tag-square-base .tag-title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    line-height: 173px;
    display: inline-block;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 10px;
    text-indent: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PhotoAlbum.vue